import React, { useEffect, useRef, useState, useMemo } from "react";
import "./productDetails.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CalendarModal from "../calendarModal/calendarModal";
import Button from "../command/Button/Button";
import OwnitInfoModal from "./ownitInfoModal";
import ProductDescriptionModal from "./productDescriptionModal";
import { ChevronRight, FileText, HelpCircle, Star } from "react-feather";
import { productDetailsClient } from "../../data/product-details";
import {
  CalendarIcon,
  CollectStore,
  DeliveryTruck,
  Effect,
  GetVarifiedIcon,
  PaymentIcon,
  RepeatIcon,
} from "../../assets/svgIcon/customIcon";
import LoaderPage from "../command/loader/loader";
import { NotFound } from "../../pages";
import AddOnsModal from "../addOnsModal/addOnsModal";
import moment from "moment";
import { getAuthCredentials, setIdvBypass, setQuoteCookies } from "../../utils/auth-utils";
import { format } from "date-fns";
import DisabledLink from "./disabledLink";
import SiteCookiesModal from "../command/siteCookiesModal/siteCookiesModal";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { PlaceHolderStoreImage } from "../../assets/svgImages/svgImages";
import { toast } from "react-toastify";
import { formatVariantOptions } from "../../utils/productVariant.helper";
import { useAuth } from "../../contexts/authContext";


// Parse specific store IDs from environment variable (comma-separated)
const SPECIFIC_STORE_IDS = (process.env.REACT_APP_SPECIFIC_STORE_IDS || "").split(",").map(id => id.trim()).filter(id => id.length > 0);

// Helper function to check if a store ID is in the specific stores list
const isSpecificStoreId = (storeId: string | undefined): boolean => {
  return storeId ? SPECIFIC_STORE_IDS.includes(storeId) : false;
};

const ProductDetails = () => {
  const navigate = useNavigate();

  const [modalShow, setModalShow] = useState(false);

  const [productDModalShow, setProductDModalShow] = useState(false);
  const [cookiesModalShow, setCookiesModalShow] = useState(false);
  // const [faqShow, setFaqShow] = useState(false);
  const [addOnsModalShow, setAddOnsModalShow] = useState(false);
  const [showOwnitModal, setShowOwnitModal] = useState(false);
  const [data, setData] = useState<any>(null);
  const [productPricing, setProductPricing] = useState<any>(null);
  const [storeDetails, setStoreDetails] = useState<any>(null);
  const [productVariants, setProductVariants] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const location = useLocation();
  const [productId, setProductId] = useState<string>("");
  const [productDescription, setProductDescription] = useState<string>("");
  const itemAddCount = localStorage.getItem("card-item");
  const [quoteProductList, setQuoteProductList] = useState<any>(null);
  const [rentPrice, setRentPrice] = useState<number | null>(null);
  const [quote, setQuote] = useState<any>(null);
  const [rentalTerm, setRentalTerm] = useState<string>("");
  const [bookingDate, setBookingDate] = useState<any>(null);
  const [productAlreadyExist, setProductAlreadyExist] = useState(false);
  const [productAvailability, setProductAvailibility] = useState(true);
  const [isProductEnabled, setIsProductEnabled] = useState(true);
  const [selectedVariants, setSelectedVariants] = useState<{ uuid: string, value: string }[]>([]);
  const [productVariantUuid, setProductVariantUuid] = useState<string | null>(null);
  const [productVariantData, setProductVariantData] = useState<any>(null);
  const [quoteProductData, setQuoteProductData] = useState<any>(null);
  const [selectedQuantity, setSelectedQuantity] = useState<number>(1);
  const [maxQuantity, setMaxQuantity] = useState<number | null>(null);
  // const [variantOptions, setVariantOptions] = useState<{
  //   option1?: string;
  //   option2?: string;
  //   option3?: string;
  // }>({});
  const [isItemFromDiffrentStore, setIsItemFromDiffrentStore] = useState(false);
  const { quoteId } = getAuthCredentials();

  const textRef = useRef(null);
  const [cookiesConsent, setCookiesConsent] = useState(
    Cookies.get("cookiesConsent")
  );
  const [quateCharges, setQuateCharges] = useState<any>();
  const [productRate, setProductRate] = useState<number | null>(null);

  const [dayPricing, setDayPricing] = useState<any>(null);
  const [weekPricing, setWeekPricing] = useState<any>(null);
  const [hourPricing, setHourPricing] = useState<any>(null);
  const [monthPricing, setMonthPricing] = useState<any>(null);
  const [monthRecurringPricing, setMonthRecurringPricing] = useState<any>(null);
  const [isAddToCartDisabled, setIsAddToCartDisabled] = useState<boolean>(false);
  const { t } = useTranslation();
  const params = new URLSearchParams(location.search);
  const productUuid = params.get("id");
  const [width, setWidth] = useState<number>(window.innerWidth);
  const [recommendedProductsCount, setRecommendedProductsCount] = useState(0);
  const { cartItems, setCartItems } = useAuth();

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  const isMobile = width <= 768;

  const handleVariantSelection = (uuid: string, value: string) => {
    const existingVariant = selectedVariants.find(variant => variant.uuid === uuid);
    if (existingVariant) {
      const updatedVariants = selectedVariants.map(variant => {
        if (variant.uuid === uuid) {
          return { uuid, value };
        }
        return variant;
      });
      setSelectedVariants(updatedVariants);
    } else {
      setSelectedVariants([...selectedVariants, { uuid, value }]);
    }

    // Reset quantity so it doesn't carry over from the previously selected variant
    setSelectedQuantity(1);

    // After updating the selected variants, fetch variant-specific product information
    fetchProductVariantInfo([...selectedVariants.filter(v => v.uuid !== uuid), { uuid, value }]);
  };

  // Function to fetch product variant information
  const fetchProductVariantInfo = (variants: { uuid: string, value: string }[]) => {
    if (!productUuid || !data?.isActive) return;

    // Prepare the request payload
    const payload: any = {
      productUuid: productUuid,
    };



    // Handle the default case when no variants are found
    if (variants.length === 1 && variants[0].uuid === 'default') {
      payload.option1 = 'default';
      // Call the API
      productDetailsClient.getProductVariant(payload)
        .then((response: any) => {
          if (response && response.uuid) {
            setProductVariantUuid(response.uuid);
            setData({
              ...data,
              productVariantUuid: response.uuid
            });
            setProductVariantData(response);
            // Set max quantity from the response, default to 0 if not provided
            const quantityAvailable = response.quantity ?? 0;
            setMaxQuantity(quantityAvailable);

            // If current quantity exceeds max, adjust it
            if (quantityAvailable > 0 && selectedQuantity > quantityAvailable) {
              setSelectedQuantity(quantityAvailable);
            }

            if (!response.isActive) {
              setIsAddToCartDisabled(true);
            } else {
              setIsAddToCartDisabled(false);
            }
            localStorage.setItem("productVariantUuid", response.uuid);
          }
        })
        .catch((error: any) => {
          console.error("Error fetching default product variant:", error);
        });
      return;
    }

    // Get the variant details for each selected variant
    if (productVariants && productVariants.length > 0) {
      // Map to track which option positions have been used
      const usedPositions = new Set();
      // Process variants based on their position field from the API
      variants.forEach(selectedVariant => {
        const variantDetails = productVariants.find((v: any) => v.uuid === selectedVariant.uuid);
        if (variantDetails) {
          // Use the position directly from the API response
          const position = variantDetails.position;


          if (position > 0 && position <= 3) {
            usedPositions.add(position);
            payload[`option${position}`] = selectedVariant.value;
          }
        }
      });
    }

    // Call the API
    productDetailsClient.getProductVariant(payload)
      .then((response: any) => {
        // Handle the response - update product data, pricing, etc.
        if (response && response.uuid) {
          setProductVariantUuid(response.uuid);
          setData({
            ...data,
            productVariantUuid: response.uuid
          });

          if (!response.isActive) {
            setIsAddToCartDisabled(true);
          } else {
            setIsAddToCartDisabled(false);
          }
          setProductVariantData(response);
          localStorage.setItem("productVariantUuid", response.uuid);

          // Set max quantity from the response
          const quantityAvailable = response.quantityAvailable || response.inventory?.quantity || response.stock || response.quantity || 0;
          setMaxQuantity(quantityAvailable);

          // Adjust selected quantity if it exceeds max
          if (quantityAvailable > 0 && selectedQuantity > quantityAvailable) {
            setSelectedQuantity(quantityAvailable);
          }
          // Store the variant options
          const options: {
            option1?: string;
            option2?: string;
            option3?: string;
          } = {};
          if (payload.option1) options.option1 = payload.option1;
          if (payload.option2) options.option2 = payload.option2;
          if (payload.option3) options.option3 = payload.option3;
          // setVariantOptions(options);
          // Update relevant product data based on the variant
          // This might include updating images, pricing, availability, etc.
        }
      })
      .catch((error: any) => {
        setLoading(false);
        console.error("Error fetching product variant:", error);
      });
  };

  // Initialize default variant selections when variants data is loaded
  useEffect(() => {
    if (productVariants && productVariants.length > 0) {
      const initialSelections: { uuid: string, value: string }[] = [];

      productVariants.forEach((variant: any) => {
        // Parse option values from string format "{\"red\",\"blue\",\"green\"}" to array
        const optionValuesString = variant.optionValues.replace(/[{}]/g, '');
        const optionValues = optionValuesString.split(',').map((value: string) =>
          value.replace(/"/g, '').trim()
        );

        if (optionValues.length > 0) {
          initialSelections.push({ uuid: variant.uuid, value: optionValues[0] });
        }
      });

      setSelectedVariants(initialSelections);

      // Call API with initial variant selections
      if (initialSelections.length > 0) {
        fetchProductVariantInfo(initialSelections);
      } else {
        // If no variants found, call API with default option
        const defaultSelection = [{ uuid: 'default', value: 'default' }];
        fetchProductVariantInfo(defaultSelection);
      }
    } else if (productVariants) {
      // If productVariants array is empty, call API with default option
      const defaultSelection = [{ uuid: 'default', value: 'default' }];
      fetchProductVariantInfo(defaultSelection);
    }
  }, [productVariants, productUuid]); // Added productUuid as it's used in fetchProductVariantInfo


  useEffect(() => {
    if (
      productPricing?.oneDay !== 0 &&
      productPricing?.oneDay != null &&
      data?.dailyChecked
    ) {
      setDayPricing([
        { label: "One Day", value: Number(productPricing?.oneDay).toFixed(2) },
        {
          label: "Two Days",
          value: Number(productPricing?.twoDays).toFixed(2),
        },
        {
          label: "Three Days",
          value: Number(productPricing?.threeDays).toFixed(2),
        },
        {
          label: "Four Days",
          value: Number(productPricing?.fourDays).toFixed(2),
        },
        {
          label: "Five Days",
          value: Number(productPricing?.fiveDays).toFixed(2),
        },
        {
          label: "Six Days",
          value: Number(productPricing?.sixDays).toFixed(2),
        },
      ]);
    }
    if (
      productPricing?.oneHour !== 0 &&
      productPricing?.oneHour != null &&
      data?.hourlyChecked
    ) {
      setHourPricing([
        {
          label: "One Hour",
          value: Number(productPricing?.oneHour).toFixed(2),
        },
        {
          label: "Two Hours",
          value: Number(productPricing?.twoHours).toFixed(2),
        },
        {
          label: "Four Hours",
          value: Number(productPricing?.fourHours).toFixed(2),
        },
      ]);
    }
    if (
      productPricing?.sevenDays !== 0 &&
      productPricing?.sevenDays != null &&
      data?.weeklyChecked
    ) {
      setWeekPricing([
        {
          label: "One week",
          value: Number(productPricing?.sevenDays).toFixed(2),
        },
        {
          label: "Two Weeks",
          value: Number(productPricing?.fourteenDays).toFixed(2),
        },
        {
          label: "Three Weeks",
          value: Number(productPricing?.twentyoneDays).toFixed(2),
        },
        {
          label: "Four Weeks",
          value: Number(productPricing?.twentyeightDays).toFixed(2),
        },
      ]);
    }

    if (
      productPricing?.oneMonth !== 0 &&
      productPricing?.oneMonth != null &&
      data?.monthlyChecked
    ) {
      let monthlyRecurring = productPricing?.oneMonth;
      // show the cheapest per month rate
      if (data?.monthlyRecurringChecked) {
        if (productPricing?.oneMonth < productPricing?.monthlyRecurring) {
          monthlyRecurring = productPricing?.oneMonth;
        } else if (productPricing?.monthlyRecurring < productPricing?.oneMonth) {
          monthlyRecurring = productPricing?.monthlyRecurring;
        }
      }
      setMonthPricing([
        {
          label: "Per Month",
          value: Number(monthlyRecurring).toFixed(2)
        },
        {
          label: "Two Months",
          value: Number(productPricing?.twoMonths).toFixed(2),
        },
        {
          label: "Three Months ",
          value: Number(productPricing?.threeMonths).toFixed(2),
        },
      ]);

    }

    if (
      productPricing?.monthlyRecurring !== 0 &&
      productPricing?.monthlyRecurring != null &&
      data?.monthlyRecurringChecked
    ) {
      setMonthRecurringPricing([
        {
          label: "One Month",
          value: Number(productPricing?.monthlyRecurring).toFixed(2)
        }
      ]);

    }
  }, [productPricing]);

  useEffect(() => {
    if (!cookiesConsent) {
      setCookiesModalShow(true);
    } else if (cookiesConsent == "rejected") {
      setCookiesModalShow(true);
    }
  }, [cookiesConsent]);
  useEffect(() => {
    if (productUuid != null && productUuid) {
      setProductId(productUuid);
      localStorage.setItem("productUuid", productUuid);
      productDetailsClient
        .getProductDetails({ productUuid: productUuid })
        .then((data: any) => {
          setData(data.product);
          localStorage.setItem("productUuid", productUuid);
          localStorage.setItem("storeUuid", data.storeDetails.uuid);
          setIdvBypass(data.storeDetails);
          setProductPricing(data.productPricing);
          setStoreDetails(data.storeDetails);
          setProductVariants(data.productVariantOptions || []);
          if (!data?.product?.isActive) {
            setIsAddToCartDisabled(true);
          }
          // If no product variants or productVariantOptions is undefined, call API with default option after API success
          if (!data.productVariantOptions) {
            const defaultSelection = [{ uuid: 'default', value: 'default' }];
            fetchProductVariantInfo(defaultSelection);
          }
          if (!data?.product?.hourlyChecked
            && !data?.product?.dailyChecked
            && !data?.product?.weeklyChecked
            && !data?.product?.monthlyChecked
            && !data?.product?.monthlyRecurringChecked) {
            setIsAddToCartDisabled(true);
          }

          setLoading(false);
        })
        .catch((error) => {
          setError(error.message);
          setLoading(false);
        });
    }
  }, [location.search, cookiesConsent]);
  const calculateProductsInCart = (products: any) => {
    let cartQuantity: any = "";

    if (products && products.length > 0) {
      cartQuantity = products.reduce((sum: any, item: any) => sum + item.productQuantity, 0);
    }

    return cartQuantity;
  }
  useEffect(() => {
    if (quoteId && storeDetails) {
      productDetailsClient
        .getProductDetailsList({ quoteUuid: quoteId })
        .then((data: any) => {
          // setData(data.products);
          setRentalTerm(data?.products[0]?.rentalTerm);
          setBookingDate({
            bookingStartDate: data?.products[0]?.productBookingStartDate,
            bookingEndDate: data?.products[0]?.productBookingEndDate,
          });
          setQuoteProductList(data.products);
          const productAlreadyExist = data.products.some(
            (obj: any) => obj.productUuid === productUuid && obj.productVariantUuid === productVariantUuid
          );

          setProductAlreadyExist(productAlreadyExist);
          setIsItemFromDiffrentStore(
            storeDetails.uuid !== data.quote.storeUuid
          );
          setQuote(data.quote);

          if (data.products.length > 0) {
            localStorage.setItem("card-item", calculateProductsInCart(data?.products));
            setCartItems(calculateProductsInCart(data?.products));
          }
          setLoading(false);
        })
        .catch((error: any) => {
          toast.error(error.message);
          setError(error.message);
          setLoading(false);
        });
    }
  }, [quoteId, storeDetails]);
  // Update quote charges with new quantity
  const updateQuoteCharges = (newQuantity: number) => {
    if (!quoteId || !data || !productVariantUuid) return;

    const mapRentalType = () =>
      quote.rentalType === "day" || quote.rentalType === "daily"
        ? "daily"
        : quote.rentalType === "monthly"
          ? "monthly"
          : quote.rentalType === "monthly-recurring"
            ? "monthly-recurring"
            : "hourly";

    const baseProductUuidForAddOn = quoteProductList.find((row: any) => row.isAddOn === false)?.productUuid ?? productId;

    // Find the existing product in the cart to get its current quantity
    const existingProduct = quoteProductList.find(
      (product: any) => product.productUuid === data.uuid && product.productVariantUuid === productVariantUuid
    );

    // Calculate total quantity by adding new quantity to existing quantity (if any)
    const totalQuantity = existingProduct
      ? (existingProduct.productQuantity || 0) + newQuantity
      : newQuantity;

    // Rebuild every cart line into the request shape (not just the one being changed) —
    // quoteProductList holds raw DB records, which are missing fields like `quantity`,
    // `rentalType` and `bookingDate` that the gateway expects on every entry.
    const products = quoteProductList.map((product: any) => ({
      productUuid: product.productUuid,
      retailerUuid: product.retailerUuid,
      storeUuid: product.storeUuid,
      rentalDuration: product.rentalTerm,
      quantity:
        product.productUuid === data.uuid && product.productVariantUuid === productVariantUuid
          ? totalQuantity
          : (product.productQuantity || 1),
      rentalType: mapRentalType(),
      bookingDate: {
        bookingStartDate: product.productBookingStartDate,
        bookingEndDate: product.productBookingEndDate,
      },
      productVariantUuid: product.productVariantUuid,
      productRetailValue: product.productRetailValue,
      baseProductUuidForAddOn,
      ...quoteId && { previousQuoteUuid: quoteId }
    }));

    // The product/variant currently being viewed may not be a saved cart line yet
    // (e.g. its quantity is being adjusted before it was ever added) — without this,
    // it would silently be dropped from the request entirely.
    if (!products.some((product: any) => product.productUuid === data.uuid && product.productVariantUuid === productVariantUuid)) {
      products.push({
        productUuid: data.uuid,
        retailerUuid: data.retailerUuid,
        storeUuid: data.storeUuid,
        rentalDuration: rentalTerm,
        quantity: totalQuantity,
        rentalType: mapRentalType(),
        bookingDate: bookingDate,
        productVariantUuid: productVariantUuid,
        productRetailValue: data.productRetailValue,
        baseProductUuidForAddOn,
        ...quoteId && { previousQuoteUuid: quoteId }
      });
    }

    const request = { products };

    productDetailsClient
      .getQuotesCharges(request)
      .then((response: any) => {
        const productPrice = response?.productRates?.find(
          (p: any) => p.productUuid === data.uuid
        );

        if (productPrice) {
          setProductRate(productPrice.productRate);
          setRentPrice(response?.orderValue);
          setQuateCharges(response);

          // Update product availability based on the API response
          const isAvailable = response.productAvailibility !== false;
          setProductAvailibility(isAvailable);
          setIsAddToCartDisabled(!isAvailable);
        }
      })
      .catch((error) => {
        console.error('Error updating quote charges:', error);
        toast.error("Failed to update quantity. Please try again.");
      });
  };

  const getQuoteCharges = () => {
    const products = quoteProductList.map(
      ({ productUuid, retailerUuid, storeUuid, productQuantity, productVariantUuid: itemVariantUuid }: any) => ({
        productUuid: productUuid,
        retailerUuid: retailerUuid,
        storeUuid: storeUuid,
        rentalDuration: rentalTerm, // rental duration,
        quantity: productUuid === data?.uuid && itemVariantUuid === productVariantUuid ? selectedQuantity : (productQuantity || 1),
        rentalType:
          quote.rentalType === "day" || quote.rentalType === "daily"
            ? "daily"
            : quote.rentalType === "monthly"
              ? "monthly"
              : quote.rentalType === "monthly-recurring"
                ? "monthly-recurring"
                : "hourly",
        bookingDate: bookingDate,
        productVariantUuid: itemVariantUuid,
        productRetailValue: data.productRetailValue,
        baseProductUuidForAddOn: quoteProductList.find((row: any) => row.isAddOn === false)?.productUuid ?? productId,
        ...quoteId && { previousQuoteUuid: quoteId }
      })
    );

    // Find the current product in the cart to get its current quantity
    const currentProductInCart = quoteProductList.find(
      (item: any) => item.productUuid === data?.uuid && item.productVariantUuid === productVariantUuid
    );
    const currentQuantityInCart = currentProductInCart?.productQuantity || 0;
    const totalQuantity = currentQuantityInCart + selectedQuantity;

    const request = {
      products: products.map((product: any) => {
        if (product.productUuid === data?.uuid && product.productVariantUuid === productVariantUuid) {
          return {
            ...product,
            quantity: totalQuantity, // Use the total quantity (cart + selected)
            productVariantUuid: productVariantUuid,
            baseProductUuidForAddOn: quoteProductList.find((row: any) => row.isAddOn === false)?.productUuid ?? productId,
          };
        }
        return product;
      }),
    };
    // Add a new product if no match is found
    if (!request.products.some((product: any) => product.productUuid === data?.uuid && product.productVariantUuid === productVariantUuid)) {
      request.products.push({
        productUuid: data?.uuid,
        retailerUuid: data?.retailerUuid,
        storeUuid: data?.storeUuid,
        rentalDuration: rentalTerm,
        quantity: selectedQuantity,
        baseProductUuidForAddOn: quoteProductList.find((row: any) => row.isAddOn === false)?.productUuid ?? productId,
        rentalType:
          quote.rentalType === "day" || quote.rentalType === "daily"
            ? "daily"
            : quote.rentalType === "monthly"
              ? "monthly"
              : quote.rentalType === "monthly-recurring"
                ? "monthly-recurring"
                : "hourly",
        bookingDate: bookingDate,
        productVariantUuid: productVariantUuid,
        productRetailValue: data.productRetailValue,
        ...quoteId && { previousQuoteUuid: quoteId }
      });
    }
    // setLoading(true);
    productDetailsClient
      .getQuotesCharges(request)
      .then((u: any) => {
        setLoading(false);

        const productPrice = u?.productRates?.filter(
          (u: any) => u.productUuid === data.uuid
        )[0];
        setProductAvailibility(u?.productAvailibility);
        setIsProductEnabled(u?.updateQuoteProduct);
        setProductRate(productPrice?.productRate);
        setRentPrice(u?.orderValue);
        setQuateCharges(u);
        setRecommendedProductsCount(u?.addOnProductCount);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.message);
        // setShowToast(true);
        // setToastType("danger");
      });
  };

  useEffect(() => {
    if (
      quoteProductList &&
      quote &&
      data &&
      !productAlreadyExist &&
      !isItemFromDiffrentStore && productVariantUuid
    ) {
      getQuoteCharges();
    }
  }, [
    quoteProductList,
    quote,
    data,
    productAlreadyExist,
    isItemFromDiffrentStore,
    productVariantUuid
  ]);

  const handleCookieConsent = (consent: string) => {
    Cookies.set("cookiesConsent", consent, { expires: 365 });
    setCookiesConsent(consent);
    setCookiesModalShow(false);
  };

  if (loading) {
    return <LoaderPage />;
  }

  if (error) {
    <NotFound errorText="500" />;
  }

  if (!data) return <NotFound errorText="404" />;

  const getBookingDatesFromLocalStorage = () => {
    const bookingDateStr = localStorage.getItem("bookingDate");
    if (bookingDateStr) {
      try {
        const bookingDate = JSON.parse(bookingDateStr);
        const { startDate, endDate, rentPrice } = bookingDate;
        return { startDate, endDate, rentPrice };
      } catch (error) {
        // console.error('Error parsing booking date from local storage:', error);
        return null;
      }
    } else {
      // console.log('No booking date found in local storage.');
      return null;
    }
  };
  const bookingDates = getBookingDatesFromLocalStorage();
  const isSameDate = () => {
    if (bookingDates) {
      return moment(bookingDates.startDate).isSame(bookingDates.endDate, "day");
    }
  };


  const addQuoteProduct = async () => {
    const productCharge = quateCharges?.productRates?.filter(
      (u: any) => u.productUuid === data?.uuid
    )[0];

    const products = quoteProductList.map(
      ({
        productUuid,
        productName,
        productRentalValue,
        productRetailValue,
        productRate,
        productDepositAmount,
        productQuantity,
        productBookingEndDate,
        productBookingStartDate,
        rentalTerm,
        productVariantUuid,
        option1,
        option2,
        option3,
        isAddOn
      }: any) => ({
        productName: productName,
        productUuid: productUuid,
        productRentalPrice: productRentalValue,
        productRetailValue: productRetailValue,
        productQuantity: productQuantity ? productQuantity : 1,
        productRate: productRate,
        productRentalTerm: rentalTerm,
        // rentalType: quote.rentalType === "day" ? "daily" : "hourly",

        bookingDate: {
          bookingStartDate: productBookingStartDate,
          bookingEndDate: productBookingEndDate,
        },
        productDepositAmount: productCharge?.productDepositAmount,
        productVariantUuid: productVariantUuid,
        option1: option1,
        option2: option2,
        option3: option3,
        isAddOn: isAddOn ?? false
      })
    );

    // Format variant options
    const variantOptions = formatVariantOptions(selectedVariants, productVariants);

    // Store variant options in localStorage
    localStorage.setItem('productVariantOptions', JSON.stringify({
      productUuid: data.uuid,
      options: variantOptions
    }));

    const value = {
      products: [
        ...products.map((product: any) => {

          if (product.productUuid === data.uuid && product.productVariantUuid === productVariantUuid) {
            // Increase quantity by the quantity selected on screen, if the product already exists with the same variant
            return {
              ...product,
              productQuantity: product.productQuantity + selectedQuantity,
              productVariantUuid: productVariantUuid,
            };
          }
          return product;
        }),
        // Add the new product if it doesn't already exist with the same UUID and variant UUID
        ...(!products.some((product: any) =>
          product.productUuid === data.uuid && product.productVariantUuid === productVariantUuid)
          ? [
            {
              productName: data.productName,
              productUuid: data.uuid,
              productRentalPrice: productCharge?.productRentalValue,
              productRetailValue: productCharge?.productRetailValue,
              productQuantity: selectedQuantity,
              productRate: productRate,
              productRentalTerm: rentalTerm,
              bookingDate: bookingDate,
              // rentalType: quote.rentalType === "day" ? "daily" : "hourly",
              productDepositAmount: productCharge?.productDepositAmount,
              productVariantUuid: productVariantUuid,
              ...variantOptions // Add variant options
            },
          ]
          : []),
      ],
      // Other properties remain unchanged
      quoteTotal: quateCharges?.orderValue,
      depositAmount: quateCharges?.depositCharge,
      serviceCharge: quateCharges?.serviceCharge,
      deliveryCharge: quateCharges?.deliveryCharge,
      instoreCollectionCharge: quateCharges?.instoreCollectionCharge,
      storeUuid: data.storeUuid,
      rentalType: quote.rentalType,
      rentalDuration: rentalTerm,
      retailerUuid: data.retailerUuid,
    };

    if (recommendedProductsCount > 0) {
      setQuoteProductData({
        value: value,
        bookingStartDate: bookingDate.bookingStartDate,
        bookingEndDate: bookingDate.bookingEndDate,
        storeUuid: data.storeUuid,
        ...(quoteId ? { quoteUuid: quoteId } : {}),
        rentalType: quote.rentalType,
        startDate: bookingDate.bookingStartDate,
        endDate: bookingDate.bookingEndDate,
        rentPrice: productCharge?.productRentalValue,
        productRetailValue: productCharge?.productRetailValue,
      });
      setAddOnsModalShow(true);
    } else {
      await productDetailsClient
        .createQuote(value)
        .then(async (res: any) => {
          if (quote?.discountCode) {
            await productDetailsClient.applyPromoCode({
              quoteUuid: res?.quote?.uuid,
              discountCode: quote?.discountCode,
            });
          }
          await productDetailsClient
            .deleteQuote({
              quoteUuid: quoteId,
            })
            .then((response: any) => {
              console.log("Deleted Successfully", response);
            })
            .catch((err: any) => {
              console.log("Error while deleting quote", err);
            });
          setQuoteCookies(res.quote.uuid);
          navigate("/cart");
        })
        .catch((error: any) => {
          toast.error(error.message);
        });
    }



  };

  const formatDate = (date: any) => {
    if (!date) return { day: "", month: "", year: "", dayOfWeek: "" };

    const day = format(date, "d");
    const month = format(date, "MMM");
    const dayOfWeek = format(date, "EEE");
    const year = format(date, "yy");
    const time = format(date, "hh:mm a")
      .replace("AM", "A.M")
      .replace("PM", "P.M");

    return {
      day,
      month,
      dayOfWeek,
      year,
      time,
    };
  };

  const FormattedDateComponent = ({ date }: { date: Date | null }) => {
    const { day, month, dayOfWeek, year } = formatDate(
      date ? new Date(date) : null
    );

    return (
      <h5 className="time-date-tag">
        {day && month ? `${day} ${month}, ` : ""}
        <span>{dayOfWeek && year ? `${dayOfWeek} ${year}` : ""}</span>
      </h5>
    );
  };

  const FormattedDateDaysComponent = ({ date }: { date: Date | null }) => {

    const time = date
      ? moment(date).format("hh:mm A").replace("AM", "A.M").replace("PM", "P.M")
      : "";

    return (
      <h5 className="m-0">
        {time && `${time} `}
        {/* <span>{dayOfWeek && year ? `${dayOfWeek} ${year}` : ''}</span> */}
      </h5>
    );
  };

  const FormattedMultiDateComponent = ({ date }: { date: Date | null }) => {
    const { day, month, dayOfWeek, year } = formatDate(
      date ? new Date(date) : null
    );

    return (
      <h5 className="m-0">
        {/* <span>{dayOfWeek && year ? `${dayOfWeek} ${year}` : ''}</span> */}
        {day && month ? `${day} ${month}, ` : ""}
        <span>{dayOfWeek && year ? `${dayOfWeek}, ${year}` : ""}</span>
      </h5>
    );
  };

  return (
    <>
      <section className="product-details-section section-space">
        <div className="container">
          <div className="row">
            {/*  */}

            <div className="offset-xl-1 offset-lg-0 col-xl-10 col-lg-12">
              <div className="effect-add-section">
                <Effect className="effect-img" />
                <div className="product-details">
                  {/*  */}
                  <div className="row col-12 col-lg-9 mx-auto justify-content-center g-0">
                    {(productVariantData?.variantImageUrl || data.productImageUrl) ? (
                      <div className="col-lg-6 order-lg-0 lg:mb-5 mb-4 position-relative">
                        <img
                          className="product-res-img img-fluid mt-10 "
                          src={productVariantData?.variantImageUrl || data.productImageUrl}
                          alt="product-img"
                        />
                        {data.isAvailableForPurchaseAfterRent && (
                          <div className="ownit-flag"><div className="ownit-text">OWN<span>it.</span></div> Try before you buy</div>
                        )}
                      </div>
                    ) : (
                      <div className="col-lg-6 order-lg-0 lg:mb-5 mb-4">
                        <div className="product-res-img mt-10 placeholder-wrapper position-relative">
                          <PlaceHolderStoreImage className="placeholder-product-image" />
                          {data.isAvailableForPurchaseAfterRent && (
                            <div className="ownit-flag"><div className="ownit-text">OWN<span>it.</span></div> Try before you buy</div>
                          )}
                        </div>
                      </div>
                    )}
                    <div className={(productVariantData?.variantImageUrl || data.productImageUrl) ? 'product-title col-lg-6 px-3  justify-content-center' : 'product-title col-lg-6 px-3  justify-content-center'}>
                      {/* src={data.productImageUrl} */}

                      <h3 className="mb-3">{data.productName}</h3>
                      <div className="d-flex flex-column align-self-start">

                        {productVariants && productVariants.length > 0 && (
                          <div className="variant-selection mb-4">
                            {productVariants.slice(0, 3).map((variant: any, variantIndex: number) => {
                              // Parse option values from string format "{\"red\",\"blue\",\"green\"}" to array
                              const optionValuesString = variant.optionValues.replace(/[{}]/g, '');
                              const optionValues = optionValuesString.split(',').map((value: string) =>
                                value.replace(/"/g, '').trim()
                              );

                              return (
                                <div key={variant.uuid} className="variant-selection-container mb-3 mt-3">
                                  <div className="variant-title mb-2">
                                    <span style={{ fontSize: '16px', fontWeight: '500' }}>{variant.optionName.charAt(0).toUpperCase() + variant.optionName.slice(1)}:</span>
                                  </div>
                                  <div className="variant-options d-flex flex-wrap gap-2">
                                    {optionValues.map((value: string) => (
                                      <button
                                        key={`${variant.uuid}-${value}`}
                                        className={`variant-option-btn ${selectedVariants.some(v => v.uuid === variant.uuid && v.value === value) ? 'selected' : ''}`}
                                        onClick={() => handleVariantSelection(variant.uuid, value)}
                                        style={{
                                          padding: '8px 16px',
                                          border: selectedVariants.some(v => v.uuid === variant.uuid && v.value === value) ? '1px solid #00B0F0' : '1px solid #ddd',
                                          borderRadius: '4px',
                                          backgroundColor: 'white',
                                          cursor: 'pointer',
                                          minWidth: '80px',
                                          textAlign: 'center'
                                        }}
                                      >
                                        {value}
                                      </button>
                                    ))}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                        <div className="quantity-label mb-2">Quantity:</div>
                        <div className="quantity-selector d-flex align-items-center align-self-start" >
                          <button
                            className="quantity-btn"
                            onClick={(e) => {
                              e.preventDefault();
                              const newQuantity = Math.max(1, selectedQuantity - 1);
                              setSelectedQuantity(newQuantity);
                              if (quoteId) {
                                updateQuoteCharges(newQuantity);
                              }
                            }}
                            disabled={selectedQuantity <= 1}
                            style={{
                              width: '30px',
                              height: '30px',
                              border: 'none',
                              cursor: selectedQuantity <= 1 ? 'not-allowed' : 'pointer',
                              fontSize: '16px',
                              opacity: selectedQuantity <= 1 ? 0.6 : 1,
                              color: selectedQuantity <= 1 ? '#999' : 'inherit'
                            }}
                          >
                            -
                          </button>
                          <div className="quantity-input-container">
                            <input
                              type="number"
                              min="1"
                              value={selectedQuantity}
                              onChange={(e) => {
                                const value = parseInt(e.target.value, 10);
                                if (!isNaN(value) && value >= 1) {
                                  const newQuantity = maxQuantity !== null ? Math.min(value, maxQuantity) : value;
                                  setSelectedQuantity(newQuantity);
                                } else if (e.target.value === '') {
                                  setSelectedQuantity(1);
                                }
                              }}
                              onBlur={(e) => {
                                let newQuantity = 1;
                                if (e.target.value !== '' && parseInt(e.target.value, 10) >= 1) {
                                  newQuantity = parseInt(e.target.value, 10);
                                  if (maxQuantity !== null && newQuantity > maxQuantity) {
                                    newQuantity = maxQuantity;
                                  }
                                }
                                setSelectedQuantity(newQuantity);
                                if (quoteId) {
                                  updateQuoteCharges(newQuantity);
                                }
                              }}
                              className="quantity-input no-spinners"
                              style={{
                                width: '50px',
                                textAlign: 'center',
                                border: 'none',
                                outline: 'none',
                                fontSize: '16px',
                                WebkitAppearance: 'none',
                                MozAppearance: 'textfield',
                                appearance: 'none',
                                margin: 0,
                                padding: 0
                              }}
                              onKeyDown={(e) => {
                                // Prevent the default behavior of up/down arrow keys
                                if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                  e.preventDefault();
                                }
                              }}
                            />
                          </div>
                          <button
                            className="quantity-btn"
                            onClick={(e) => {
                              e.preventDefault();
                              const newQuantity = selectedQuantity + 1;
                              if (maxQuantity === null || newQuantity <= maxQuantity) {
                                setSelectedQuantity(newQuantity);
                                if (quoteId) {
                                  updateQuoteCharges(newQuantity);
                                }
                              }
                            }}
                            disabled={maxQuantity !== null && selectedQuantity >= maxQuantity}
                            style={{
                              width: '30px',
                              height: '30px',
                              border: 'none',
                              cursor: (maxQuantity !== null && selectedQuantity >= maxQuantity) ? 'not-allowed' : 'pointer',
                              fontSize: '16px',
                              opacity: (maxQuantity !== null && selectedQuantity >= maxQuantity) ? 0.6 : 1,
                              color: (maxQuantity !== null && selectedQuantity >= maxQuantity) ? '#999' : 'inherit'
                            }}
                          >
                            +
                          </button>
                        </div>
                      </div>
                      <a href="#" className="shoplink mt-3" onClick={(event) => {
                        event.preventDefault(); navigate('/shop')
                      }}>
                        {isSpecificStoreId(storeDetails.uuid) ? <img style={{width:"100%", maxWidth:"350px", height:"auto"}} src="/images/option-a-banner.svg" alt="logo" />
                          : <>
                            View all products
                            <span>
                              <ChevronRight size={16}></ChevronRight>
                              <ChevronRight size={16} className="second-arrow"></ChevronRight>
                            </span>
                          </>}
                      </a>
                    </div>

                  </div>

                  {/*  */}
                  {/* <div className="price-wrapper">
                    <div className="row g-sm-4 g-2 justify-content-center">
                      {selectedPricingNew &&
                        selectedPricingNew.map((pricesData: any, index: number) => {
                          return (
                            <div key={index} className="col-xl-2 col-md-3 col-4">
                              <div
                                className={
                                  index === 1
                                    ? "price-box"
                                    : "price-box recommend-box"
                                }
                              >
                                {index === 1 && (
                                  <span className="recommend">
                                    {t("recommended")}
                                  </span>
                                )}
                                <h4 className="price-value">£{pricesData?.value}</h4>
                                {pricesData?.label.includes("Month")
                                  // && <span className="per-month-label">Per month</span>
                                }
                                <span className="price-day">
                                  {t(pricesData?.label)}
                                </span>
                              </div>
                            </div>
                          );
                        })}

                      // <div className="col-xl-2 col-md-3 col-4">
                      //   <div className="price-box recommend-box">
                      //     <span className="recommend">{t("recommended")}</span>
                      //     <h4 className="price-value">
                      //       £{productPricing?.sevenDays}
                      //     </h4>
                      //     <span className="price-day">1 {t("week")}</span>
                      //   </div>
                      // </div>
                      // <div className="col-xl-2 col-md-3 col-4">
                      //   <div className="price-box">
                      //     <h4 className="price-value">
                      //       £{productPricing?.twentyeightDays}
                      //     </h4>
                      //     <span className="price-day">4 {t("weeks")}</span>
                      //   </div>
                      // </div> 
                    </div>

                  </div> */}
                  {/*  */}
                  <div className="d-flex justify-content-center delivery-status-col">
                    {data?.isProductDeliverable && !data?.isCollectFromStoreEnabled && (
                      <p className="delivery-status">
                        <DeliveryTruck className="collect-img delivery-t delivery-t-icon" />
                        {"    "} Delivery Available
                      </p>
                    )}
                    {data?.isCollectFromStoreEnabled && !data?.isProductDeliverable && (
                      <p className="delivery-status">
                        <CollectStore className="collect-img instore-t-icon" />
                        {"    "}Collect from Store
                      </p>
                    )}

                    {data?.isCollectFromStoreEnabled && data?.isProductDeliverable && (
                      <p className="delivery-status">
                        <CollectStore className="collect-img instore-t-icon" />
                        {"    "}Collect from Store or Delivery Available
                      </p>
                    )}
                  </div>



                  <div className="row gx-lg-5">
                    <div className="col-lg-6 order-lg-0 order-1 section-select-date">
                      <div className="store-wrapper">
                        <div className="store-img">
                          {/* <Image src='https://i.pinimg.com/736x/06/87/b9/0687b9e9693b8dd07f9cd6c36b2884e9.jpg' alt='store-image' className='img-fluid' /> */}
                          {/* <Image src={!storeDetails.storeLogo ? storeDetails.storeLogo : './images/placeholder-store.svg'} alt='store-image' className='img-fluid' /> */}
                          {/* <img src={imageSrc} alt='store-image' className='img-fluid' /> */}
                          {storeDetails?.storeLogo ? (
                            <img
                              className="img-fluid"
                              src={storeDetails?.storeLogo}
                              alt="verify-identity-img"
                            />
                          ) : (
                            <PlaceHolderStoreImage />
                          )}
                        </div>
                        <div className="store-details">
                          <div className="store-name">
                            <h5>{storeDetails?.storeName}</h5>
                            <div className="ratting-box">
                              <Star className="ratting-star fill" />
                              <Star className="ratting-star fill" />
                              <Star className="ratting-star fill" />
                              <Star className="ratting-star fill" />
                              <Star className="ratting-star fill" />
                              <span>{`(50)`}</span>
                            </div>
                          </div>
                          <p className="store-website">
                            {storeDetails?.storeWebUrl}
                          </p>
                        </div>
                      </div>
                      <div className="product-description">
                        <div className="details-title">
                          <FileText className="file-text" />
                          <h4>{t("description")}</h4>
                        </div>
                        <p ref={textRef} className="ellipsis-threeline">
                          {data.productDescription}
                        </p>
                        <div className="pro-description">
                          {data.productDescription.length >= 200 && (
                            <Link
                              className="read-more-link"
                              to={"#"}
                              onClick={(e) => {
                                e.preventDefault();
                                setProductDescription(data.productDescription);
                                setProductDModalShow(true);
                              }}
                            >
                              {t("read-more")}...
                            </Link>
                          )}
                        </div>
                      </div>
                    </div>



                    <div className="col-lg-6 order-lg-1 order-0">
                      {!data?.isAvailableForPurchaseAfterRent && (
                        <div className="calendar-availability">
                          <div className="details-title calendar-title">
                            <CalendarIcon />
                            <h4>{t("check-availability-and-price")}</h4>
                          </div>
                          <div
                            className={`calendar-date ${isSameDate() && quote?.rentalType == 'hourly' ? "date-space-add" : ""
                              }`}
                          >
                            <DisabledLink
                              to=""
                              onClick={(e: any) => {
                                e.preventDefault();
                                setModalShow(true);
                              }}
                              className="date-wrapper"
                              disabled={(itemAddCount && itemAddCount !== "0") || isAddToCartDisabled}
                            >
                              {itemAddCount &&
                                itemAddCount !== "0" &&
                                isSameDate() && (
                                  <FormattedDateComponent
                                    date={bookingDates?.startDate}
                                  />
                                )}
                              <div
                                className={`cal-date start-dtime ${isSameDate() && quote?.rentalType == 'hourly' ? "day-selection" : ""
                                  }`}
                              >
                                {itemAddCount && itemAddCount !== "0" ? (
                                  <>
                                    {isSameDate() && quote?.rentalType == 'hourly' ? (
                                      <>
                                        <h4>{t("start-time")}</h4>
                                        <FormattedDateDaysComponent
                                          date={bookingDates?.startDate}
                                        />
                                      </>
                                    ) : (
                                      <>
                                        <h4>{t("start-date")}</h4>
                                        <FormattedMultiDateComponent
                                          date={bookingDates?.startDate}
                                        />
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <h4>{t("start-date")}</h4>
                                    <span>{t("add-date")}</span>
                                  </>
                                )}
                              </div>
                              <div
                                className={`cal-date ${isSameDate() && quote?.rentalType == 'hourly' ? "day-selection" : ""
                                  }`}
                              >
                                {itemAddCount && itemAddCount !== "0" ? (
                                  <>
                                    {isSameDate() && quote?.rentalType == 'hourly' ? (
                                      <>
                                        <h4>{t("end-time")}</h4>
                                        <FormattedDateDaysComponent
                                          date={bookingDates?.endDate}
                                        />
                                      </>
                                    ) : (
                                      <>
                                        <h4>{t("end-date")}</h4>
                                        <FormattedMultiDateComponent
                                          date={bookingDates?.endDate}
                                        />
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <h4>{t("end-date")}</h4>
                                    <span>{t("add-date")}</span>
                                  </>
                                )}
                              </div>
                            </DisabledLink>
                          </div>
                        </div>
                      )}

                      {isItemFromDiffrentStore ||
                        // productAlreadyExist ||
                        !productAvailability ||
                        !isProductEnabled ? (
                        <>
                          {isItemFromDiffrentStore ? (
                            <p className="availability-validation">
                              The scanned product is from a different store.
                            </p>
                          ) :
                            // productAlreadyExist ? (
                            //   <p className="availability-validation">
                            //     This item is already in your cart.
                            //   </p>
                            // ) : 
                            !productAvailability ? (
                              <p className="availability-validation">
                                The selected product is not available on your
                                chosen dates. Please select different dates.
                              </p>
                            ) : (
                              !isProductEnabled && (
                                <>
                                  {data.dailyChecked && !data.weeklyChecked && (
                                    <p className="availability-validation">
                                      The maximum Rental duration for this item is
                                      6 days, please re-select your dates.
                                    </p>
                                  )}

                                  {!data.dailyChecked && data.weeklyChecked && (
                                    <p className="availability-validation">
                                      The minimal Rental duration for this item is
                                      7 days, please re-select your dates.
                                    </p>
                                  )}
                                </>
                              )
                            )}

                          <div className="pro-details-btns">
                            <Button
                              onClick={() => navigate("/cart")}
                              btnText={t("Go to Cart")}
                            />
                          </div>
                        </>
                      ) : (

                        <>
                          {
                            <div>
                              {data.isAvailableForPurchaseAfterRent && (
                                <div className="ownit-fixed">
                                  <div className="d-flex">
                                    <div className="ownit-text-black">OWN<span>it</span></div>
                                    Try before you buy!
                                  </div>
                                  <div className="learn-more-link">
                                    <a href="#" onClick={(e) => { e.preventDefault(); setShowOwnitModal(true); }}>Learn more</a>
                                  </div>
                                </div>
                              )}
                              <OwnitInfoModal
                                show={showOwnitModal}
                                onHide={() => setShowOwnitModal(false)}
                              />
                              {(!isMobile || !isAddToCartDisabled) && <div className={isAddToCartDisabled ? 'disabled-link' : 'pro-details-btns'}>
                                <Button
                                  onClick={() =>
                                    itemAddCount && itemAddCount !== "0"
                                      ? addQuoteProduct()
                                      : setModalShow(true)
                                  }
                                  disabled={isAddToCartDisabled}
                                  btnText={
                                    productAlreadyExist || parseInt(localStorage.getItem("card-item") || "0", 10) > 0
                                      ? t("Add to Cart")
                                      : data.isAvailableForPurchaseAfterRent
                                        ? `${t("product-page-trial-text")}\n${t("continue")}`
                                        : t("continue")
                                  }
                                  isProductPage={true}
                                />
                              </div>}
                              {
                                isAddToCartDisabled &&
                                <p className="availability-validation mt-2 add-to-cart-disabled-message mb-lg-0">
                                  {t("product-currently-not-available")}
                                </p>
                              }
                            </div>
                          }
                        </>
                      )}
                    </div>
                  </div>
                  {/*  */}
                </div>
              </div>
            </div>
            <div className="offset-xl-1 offset-lg-0 col-xl-10 col-lg-12">
              <div className="renticy-steps">
                <div className="row">
                  <div className="col-md-12">
                    <h3 className="renticy-steps-title">
                      {t("renting")}
                      <span>.</span> {t("made")}
                      <span>.</span> {t("simple")}
                      <span>.</span>
                    </h3>
                  </div>
                  <div className="col-xxl-3 col-xl-6 col-md-6">
                    <div className="renticy-step-box">
                      <div className="renticy-icons">
                        <CalendarIcon />
                      </div>
                      <div className="renticy-details">
                        <h4>{t("customise-your-rental")}</h4>
                        <p>{t("customise-your-rental-description")}</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-6 col-md-6">
                    <div className="renticy-step-box">
                      <div className="renticy-icons">
                        <GetVarifiedIcon />
                      </div>
                      <div className="renticy-details">
                        <h4>{t("get-verified")}</h4>
                        <p>{t("get-verified-description")}</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-6 col-md-6">
                    <div className="renticy-step-box">
                      <div className="renticy-icons">
                        <PaymentIcon className="payment-icon" />
                      </div>
                      <div className="renticy-details">
                        <h4>{t("simple-payment")}</h4>
                        <p>{t("simple-payment-description")}</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-6 col-md-6">
                    <div className="renticy-step-box">
                      <div className="renticy-icons">
                        <RepeatIcon />
                      </div>
                      <div className="renticy-details">
                        <h4>
                          {t("return")}. {t("repeat")}.
                        </h4>
                        <p>{t("return-repeat-description")}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* FAQ link removed as requested */}
          </div>
        </div>
      </section>

      {/* Calender Modal Show */}
      <CalendarModal
        show={modalShow}
        details={{ ...data, edit: false, storeDetails: storeDetails }}
        productuuid={productId}
        onHide={() => setModalShow(false)}
        productpricing={productPricing}
        productVariantUuid={productVariantUuid}
        variantOptions={formatVariantOptions(selectedVariants, productVariants)}
        openAddOnModal={() => setAddOnsModalShow(true)}
        setQuoteProductData={setQuoteProductData}
        selectedQuantity={selectedQuantity}
      />

      {/* Product Description Modal */}
      <ProductDescriptionModal
        show={productDModalShow}
        description={productDescription}
        productDonHide={() => setProductDModalShow(false)}
      />

      {/* Faq's Modal */}
      {/* <FaqModal
        show={faqShow}
        faqModalHide={() => setFaqShow(false)}
      /> */}

      {/* Cookies Modal */}
      <SiteCookiesModal
        show={cookiesModalShow}
        cookiesHide={() => setCookiesModalShow(false)}
        onAccept={() => handleCookieConsent("isAccepted")}
        onReject={() => handleCookieConsent("rejected")}
        onSettings={() => handleCookieConsent("settings")}
      />

      {/* Add-Ons Modal */}
      <AddOnsModal
        show={addOnsModalShow}
        onHide={() => setAddOnsModalShow(false)}
        quoteProductData={quoteProductData}
        productuuid={productId}
        onAddToCart={(productId) => {
          setAddOnsModalShow(false);
        }}
      />

      {/* <ToastMessage
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
        type={toastType}
      /> */}
    </>
  );
};

export default ProductDetails;
